import React from 'react';
import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Navigation.css';
import logoNavbar from '../assets/logos/logo-ai-black-horizontal.png';

const Navigation: React.FC = () => {

  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Navbar.Brand as={Link} to="/home"><img src={logoNavbar} alt="Revealer Logo" className="navbar-logo" /></Navbar.Brand>
    </Navbar>
  );
};

export default Navigation;